<div class="due-quotation-dialog">
  <div class="dialog-header">
    <div class="header-content">
      <i class="pi pi-file-edit header-icon"></i>
      <h3>Due Quotations</h3>
      <span class="badge-count">{{filteredDueQuotations.length}}</span>
    </div>
    <div class="header-actions">
      <p-button id="custom-icon" icon="pi pi-times" class="p-button-rounded p-button-text close-btn"
        (click)="closeDialog()" pTooltip="Close" pTooltipPosition="left" [style]="{'color': '#ffffff'}">
      </p-button>
    </div>
  </div>

  <div class="dialog-content">
    <!-- Enhanced Filter Bar -->
    <div class="filter-bar">
      <div class="global-search">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input type="text" pInputText placeholder="Search quotations..." [(ngModel)]="globalFilter"
            (input)="onGlobalFilter($event)" class="w-full">
        </span>
      </div>

      <div class="filter-controls">
        <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus" placeholder="All Statuses"
          optionLabel="label" [showClear]="true" (onChange)="filterByStatus()" class="status-filter">
          <ng-template let-option pTemplate="item">
            <p-tag [value]="option.label"
              [severity]="option.value === 'Overdue' ? 'danger' : option.value === 'Pending' ? 'warning' : 'info'">
            </p-tag>
          </ng-template>
        </p-dropdown>

        <p-button icon="pi pi-filter" label="More Filters" class="p-button-outlined" (click)="toggleAdvancedFilters()">
        </p-button>
      </div>
    </div>

    <!-- Advanced Filters Panel -->
    <div class="advanced-filters" *ngIf="showAdvancedFilters">
      <div class="filter-row">
        <div class="filter-group">
          <label>Customer Name</label>
          <p-dropdown [(ngModel)]="selectedCustomerName" [options]="customerNameOptions"
            placeholder="Select customer name" [showClear]="true" optionLabel="label" optionValue="value"
            [filter]="true" filterBy="label" [virtualScroll]="true" [virtualScrollItemSize]="38"
            style="max-width: 200px;">
          </p-dropdown>
        </div>

        <div class="filter-group" style="align-items:end;">
          <label>Last Invoice Date Range</label>
          <p-calendar [(ngModel)]="lastInvoiceDateRange" selectionMode="range" [readonlyInput]="true"
            inputId="lastInvoiceRange" placeholder="Select last invoice date range" dateFormat="yy-mm-dd"
            style="max-width: 200px;">
          </p-calendar>
        </div>
      </div>

      <div class="filter-actions">
        <p-button label="Apply Filters" icon="pi pi-check" class="p-button-sm" (click)="applyAdvancedFilters()">
        </p-button>
        <p-button label="Reset" icon="pi pi-refresh" class="p-button-sm p-button-outlined"
          (click)="resetAdvancedFilters()">
        </p-button>
      </div>
    </div>

    <!-- Quotations Table with Expandable Details -->
    <p-table #dt [value]="filteredDueQuotations" [columns]="cols" [scrollable]="true" scrollHeight="300px"
      [resizableColumns]="true" styleClass="p-datatable-gridlines p-datatable-striped" [paginator]="true" [rows]="10"
      [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} quotations"
      [globalFilterFields]="['quotationNo', 'invoiceNo', 'customerName', 'customerEmail', 'jobNumber', 'poNumber']">

      <ng-template pTemplate="caption">
        <div class="table-caption">
          <span class="caption-text">
            <i class="pi pi-info-circle"></i> Showing quotations with pending payments
          </span>
          <div class="export-buttons">
            <p-button icon="pi pi-file-excel" label="Export Full" class="p-button-text p-button-sm"
              (click)="exportToExcel(true)">
            </p-button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [style.width]="col.width" pResizableColumn>
            <div class="column-header">
              <span>{{col.header}}</span>
              <i *ngIf="col.sortable" class="pi pi-sort-alt sort-icon"></i>
            </div>
          </th>
          <th style="width: 120px">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-quotation let-rowIndex="rowIndex">
        <!-- Main row -->
        <tr
          [ngClass]="{'row-overdue': quotation.status === 'Overdue', 'row-expanded': isQuotationExpanded(quotation.quotationNo)}">
          <td>
            <span class="quotation-number">{{quotation.quotationNo}}</span>
            <div class="subtext">Created: {{quotation.quotationDate | date:'shortDate'}}</div>
          </td>
          <td>
            <div class="customer-info">
              <span class="customer-name">{{quotation.customerName}}</span>
              <span class="customer-email">{{quotation.customerEmail}}</span>
            </div>
          </td>
          <td>
            <span class="invoice-number">{{quotation.invoiceNo || '--'}}</span>
          </td>
          <td>
            <div class="date-cell">
              <span>{{quotation.lastInvoiceDate | date:'shortDate'}}</span>
            </div>
          </td>
          <td>
            <div class="date-cell due-date">
              <span>{{quotation.dueDate | date:'shortDate'}}</span>
              <i class="pi pi-clock"
                [ngClass]="{'overdue-icon': quotation.delayedDays > 0, 'pending-icon': quotation.delayedDays === 0}">
              </i>
              <p-tag [value]="getDelayedDaysLabel(quotation.delayedDays)"
                [severity]="getDelayedDaysSeverity(quotation.delayedDays)"
                [icon]="getDelayedDaysIcon(quotation.delayedDays)" class="delayed-tag">
              </p-tag>
            </div>
          </td>
          <td>
            <div class="amount-cell">
              <span class="price-cell">{{quotation.price | currency:'USD':'symbol':'1.2-2'}}</span>
              <div class="subtext">Outstanding: {{quotation.outstandingAmount | currency:'USD':'symbol':'1.2-2'}}</div>
            </div>
          </td>
          <td>
            <p-tag [severity]="quotation.status === 'Overdue' ? 'danger' : 'warning'" [value]="quotation.status"
              [icon]="quotation.status === 'Overdue' ? 'pi pi-exclamation-circle' : 'pi pi-clock'">
            </p-tag>
          </td>
          <td class="action-cell">
            <div class="action-buttons">
              <button pButton pRipple
                [icon]="isQuotationExpanded(quotation.quotationNo) ? 'pi pi-eye-slash' : 'pi pi-eye'"
                class="p-button-rounded p-button-text p-button-sm"
                [pTooltip]="isQuotationExpanded(quotation.quotationNo) ? 'Hide Details' : 'View Details'"
                [ngClass]="{'expanded-btn': isQuotationExpanded(quotation.quotationNo)}"
                (click)="viewQuotation(quotation)">
              </button>
              <button pButton pRipple icon="pi pi-file-pdf" class="p-button-rounded p-button-text p-button-sm"
                pTooltip="Generate PDF Report" (click)="generatePDFReport(quotation)">
              </button>
            </div>
          </td>
        </tr>

        <!-- Expandable details row -->
        <tr *ngIf="isQuotationExpanded(quotation.quotationNo)" class="expanded-detail-row">
          <td colspan="8" class="p-0">
            <div class="quotation-details-panel" [@slideDown]>
              <div class="details-container">
                <div class="details-grid">

                  <!-- Basic Information Section -->
                  <div class="detail-section">
                    <h6 class="section-title">
                      <i class="pi pi-info-circle section-icon"></i>
                      Basic Information
                    </h6>
                    <div class="detail-items">
                      <div class="detail-item">
                        <span class="detail-label">Quotation Date:</span>
                        <span class="detail-value">{{ quotation.quotationDate ? (quotation.quotationDate |
                          date:'mediumDate') : 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Job Number:</span>
                        <span class="detail-value font-semibold">{{ quotation.jobNumber || 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">PO Number:</span>
                        <span class="detail-value font-semibold">{{ quotation.poNumber || 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Customer Type:</span>
                        <p-tag [value]="quotation.customerType" severity="info" class="detail-value"></p-tag>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Customer Email:</span>
                        <span class="detail-value">
                          <a [href]="'mailto:' + quotation.customerEmail" class="email-link">
                            {{ quotation.customerEmail || 'N/A' }}
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>

                  <!-- Financial Summary Section -->
                  <div class="detail-section">
                    <h6 class="section-title">
                      <i class="pi pi-dollar section-icon"></i>
                      Financial Summary
                    </h6>
                    <div class="detail-items">
                      <div class="detail-item">
                        <span class="detail-label">Total Invoice Amount:</span>
                        <span class="detail-value font-bold text-lg">{{ quotation.price | currency }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Total Paid:</span>
                        <span class="detail-value text-green-600 font-semibold">{{ quotation.totalPaid | currency
                          }}</span>
                      </div>
                      <div class="detail-item highlight-item">
                        <span class="detail-label">Outstanding Amount:</span>
                        <span class="detail-value text-red-600 font-bold text-lg">{{ quotation.outstandingAmount |
                          currency }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Payment Progress:</span>
                        <div class="detail-value">
                          <p-progressBar [value]="(quotation.totalPaid / quotation.price) * 100" [showValue]="false"
                            styleClass="mb-2 progress-bar">
                          </p-progressBar>
                          <small class="progress-text">
                            {{ ((quotation.totalPaid / quotation.price) * 100) | number:'1.1-1' }}% Paid
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Invoice Process Section -->
                  <div class="detail-section full-width">
                    <h6 class="section-title">
                      <i class="pi pi-file section-icon"></i>
                      Invoice Process
                    </h6>
                    <div class="process-container">
                      <div class="process-header">
                        <span class="process-count">Total Invoices: {{ quotation.invoices?.length || 0 }}</span>
                      </div>
                      <div class="process-timeline" *ngIf="quotation.invoices && quotation.invoices.length > 0">
                        <div class="timeline-item" *ngFor="let invoice of quotation.invoices; let i = index"
                          [ngClass]="{'latest-invoice': i === 0}">
                          <div class="timeline-marker">
                            <i class="pi pi-file-edit"></i>
                          </div>
                          <div class="timeline-content">
                            <div class="timeline-header">
                              <h6 class="invoice-number">{{ invoice.invoiceNo }}</h6>
                              <span class="invoice-date">{{ invoice.date | date:'shortDate' }}</span>
                              <p-tag *ngIf="i === 0" value="Latest" severity="success" class="latest-tag"></p-tag>
                            </div>
                            <div class="timeline-details">
                              <div class="detail-row">
                                <span class="label">Amount:</span>
                                <span class="value">{{ invoice.invoicePrice | currency }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="label">Due Date:</span>
                                <span class="value">{{ invoice.paymentDueDate | date:'shortDate' }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="label">BL Date:</span>
                                <span class="value">{{ invoice.blDate | date:'shortDate' }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="no-data" *ngIf="!quotation.invoices || quotation.invoices.length === 0">
                        <i class="pi pi-info-circle"></i>
                        <span>No invoice information available</span>
                      </div>
                    </div>
                  </div>

                  <!-- Payment Process Section -->
                  <div class="detail-section full-width">
                    <h6 class="section-title">
                      <i class="pi pi-credit-card section-icon"></i>
                      Payment Process
                    </h6>
                    <div class="process-container">
                      <div class="process-header">
                        <span class="process-count">Total Payments: {{ quotation.payments?.length || 0 }}</span>
                        <span class="payment-total">Total Paid: {{ quotation.totalPaid | currency }}</span>
                      </div>
                      <div class="process-timeline" *ngIf="quotation.payments && quotation.payments.length > 0">
                        <div class="timeline-item" *ngFor="let payment of quotation.payments; let i = index"
                          [ngClass]="{'latest-payment': i === 0}">
                          <div class="timeline-marker payment-marker">
                            <i class="pi pi-credit-card"></i>
                          </div>
                          <div class="timeline-content">
                            <div class="timeline-header">
                              <h6 class="payment-reference">Payment #{{ i + 1 }}</h6>
                              <span class="payment-date">{{ payment.paymentReceivedDate | date:'shortDate' }}</span>
                              <p-tag *ngIf="i === 0" value="Latest" severity="info" class="latest-tag"></p-tag>
                            </div>
                            <div class="timeline-details">
                              <div class="detail-row">
                                <span class="label">Invoice No:</span>
                                <span class="value">{{ payment.invoiceNo || 'N/A' }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="label">Amount:</span>
                                <span class="value payment-amount">{{ payment.paymentPrice | currency }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="label">Payment Date:</span>
                                <span class="value">{{ payment.paymentReceivedDate | date:'mediumDate' }}</span>
                              </div>
                              <div class="detail-row">
                                <span class="label">Status:</span>
                                <span class="value">
                                  <p-tag [value]="payment.paymentReceived ? 'Received' : 'Pending'"
                                    [severity]="payment.paymentReceived ? 'success' : 'warning'"
                                    [icon]="payment.paymentReceived ? 'pi pi-check' : 'pi pi-clock'">
                                  </p-tag>
                                </span>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="no-data" *ngIf="!quotation.payments || quotation.payments.length === 0">
                        <i class="pi pi-info-circle"></i>
                        <span>No payment information available</span>
                      </div>
                    </div>
                  </div>

                  <!-- Payment Status Section -->
                  <div class="detail-section full-width">
                    <h6 class="section-title">
                      <i class="pi pi-calendar section-icon"></i>
                      Payment Status
                    </h6>
                    <div class="status-cards">
                      <div class="status-card current-status">
                        <div class="card-header">Current Status</div>
                        <div class="card-content">
                          <p-tag [value]="getDelayedDaysLabel(quotation.delayedDays)"
                            [severity]="getDelayedDaysSeverity(quotation.delayedDays)"
                            [icon]="getDelayedDaysIcon(quotation.delayedDays)" styleClass="status-tag">
                          </p-tag>
                        </div>
                      </div>

                      <div class="status-card">
                        <div class="card-header">Due Date</div>
                        <div class="card-content">
                          <div class="date-display">{{ quotation.dueDate | date:'mediumDate' }}</div>
                        </div>
                      </div>

                      <div class="status-card">
                        <div class="card-header">Days Status</div>
                        <div class="card-content">
                          <div class="days-display" [ngClass]="{
                                 'overdue': quotation.delayedDays > 0, 
                                 'pending': quotation.delayedDays < 0, 
                                 'due-today': quotation.delayedDays === 0
                               }">
                            {{ quotation.delayedDays === 0 ? 'Due Today' : (quotation.delayedDays) + ' days' }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Action Buttons Section -->
                <div class="details-actions">
                  <div class="action-group">
                    <button pButton pRipple label="Generate PDF Report" icon="pi pi-file-pdf"
                      class="p-button-sm p-button-primary" (click)="generatePDFReport(quotation)">
                    </button>
                  </div>

                  <button pButton pRipple label="Collapse" icon="pi pi-chevron-up"
                    class="p-button-sm p-button-text collapse-btn" (click)="viewQuotation(quotation)">
                  </button>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="cols.length + 1">
            <div class="empty-state">
              <i class="pi pi-inbox empty-icon"></i>
              <h4>No quotations found</h4>
              <p>Try adjusting your filters or search criteria</p>
              <p-button label="Clear All Filters" icon="pi pi-filter-slash" class="p-button-text"
                (click)="clearFilters()">
              </p-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- Email Content Dialog (unchanged) -->
  <p-dialog header="Payment Reminder Email" [(visible)]="showEmailDialog" [modal]="true"
    [style]="{width: '80vw', maxWidth: '800px'}" [closable]="true" [draggable]="true" [resizable]="true"
    styleClass="email-content-dialog">

    <div class="email-preview-container" *ngIf="emailContent.to">

      <!-- Email Header -->
      <div class="email-header">
        <h4><i class="pi pi-envelope mr-2"></i>Email Preview</h4>
        <p class="email-subtitle">Review the content below and copy to your email client</p>
      </div>

      <!-- Email Fields -->
      <div class="email-fields">
        <!-- To Field -->
        <div class="field">
          <label class="field-label">To:</label>
          <div class="field-content">
            <input type="text" pInputText [(ngModel)]="emailContent.to" readonly class="w-full email-field">
            <button pButton icon="pi pi-copy" class="p-button-text p-button-sm copy-btn" pTooltip="Copy To Address"
              (click)="copyToClipboard(emailContent.to)">
            </button>
          </div>
        </div>

        <!-- Subject Field -->
        <div class="field">
          <label class="field-label">Subject:</label>
          <div class="field-content">
            <input type="text" pInputText [(ngModel)]="emailContent.subject" class="w-full email-field">
            <button pButton icon="pi pi-copy" class="p-button-text p-button-sm copy-btn" pTooltip="Copy Subject"
              (click)="copyToClipboard(emailContent.subject)">
            </button>
          </div>
        </div>

        <!-- Body Field -->
        <div class="field">
          <label class="field-label">Message Body:</label>
          <div class="field-content">
            <textarea pInputTextarea [(ngModel)]="emailContent.body" [rows]="15" class="w-full email-body"
              [style]="{'resize': 'vertical'}">
            </textarea>
            <button pButton icon="pi pi-copy" class="p-button-text p-button-sm copy-btn" pTooltip="Copy Message Body"
              (click)="copyToClipboard(emailContent.body)">
            </button>
          </div>
        </div>
      </div>

      <!-- Quick Actions -->
      <div class="quick-actions">
        <div class="action-buttons" style="display: flex; justify-content: space-between;">
          <button pButton label="Copy All Content" icon="pi pi-copy" class="p-button-primary"
            (click)="copyToClipboard('To: ' + emailContent.to + '\nSubject: ' + emailContent.subject + '\n\n' + emailContent.body)">
          </button>

          <a (click)="openInOutlook()" href="javascript:void(0)" class="p-button p-button-outlined"
            style="text-decoration: none">
            <i class="pi pi-external-link"></i>
            <span>Open in Outlook</span>
          </a>
        </div>
      </div>

      <!-- Instructions -->
      <div class="instructions">
        <h6><i class="pi pi-info-circle mr-2"></i>Instructions:</h6>
        <ol>
          <li>Review and edit the email content above if needed</li>
          <li>Click "Copy All Content" or copy individual fields</li>
          <li>Open your email client (Outlook, Gmail, etc.)</li>
          <li>Paste the content into a new email</li>
          <li>Save as draft or send when ready</li>
        </ol>
      </div>

    </div>

    <!-- Dialog Footer -->
    <ng-template pTemplate="footer">
      <div class="dialog-footer-actions">
        <button pButton label="Close" icon="pi pi-times" class="p-button-secondary" (click)="closeEmailDialog()">
        </button>
      </div>
    </ng-template>
  </p-dialog>

</div>

<!-- Dialog footer (unchanged) -->
<div class="dialog-footer">
  <div class="summary-stats">
    <div class="stat-item">
      <span class="stat-label">Total Due:</span>
      <span class="stat-value">{{totalDue | currency:'USD':'symbol':'1.2-2'}}</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">Overdue:</span>
      <span class="stat-value overdue">{{overdueTotal | currency:'USD':'symbol':'1.2-2'}}</span>
    </div>
    <div class="stat-item">
      <span class="stat-label">Pending:</span>
      <span class="stat-value pending">{{pendingTotal | currency:'USD':'symbol':'1.2-2'}}</span>
    </div>
  </div>

  <div class="footer-actions">
    <p-button label="Clear All" icon="pi pi-filter-slash" class="p-button-outlined" (click)="clearFilters()">
    </p-button>
    <p-button label="Close" icon="pi pi-times" class="p-button-secondary" (click)="closeDialog()">
    </p-button>
  </div>
</div>